import client from './client.ts';
import axios from 'axios';

export type InventoryItem = {
  id?: number;
  tenantId?: number;
  sku: string;
  name: string;
  barcode?: string;
  purchasePrice?: number;
  sellingPrice?: number;
  taxRate?: number;
  parLevel?: number;
  minQty?: number;
  costMethod?: string;
  trackLot?: boolean;
  trackSerial?: boolean;
  shelfLifeDays?: number;
  active?: boolean;
};

export type InventoryBatch = {
  id?: number;
  tenantId?: number;
  item?: InventoryItem | { id: number };
  batchCode?: string;
  manufactureDate?: string; // YYYY-MM-DD
  expiryDate?: string; // YYYY-MM-DD
  unitCost?: number;
  quantity?: number;
  receivedAt?: string;
  supplierId?: number;
  notes?: string;
};

export async function listItems(): Promise<InventoryItem[]> {
  const res = await client.get('/api/v1/inventory/items');
  return res.data as InventoryItem[];
}

export async function createItem(payload: InventoryItem): Promise<InventoryItem> {
  const res = await client.post('/api/v1/inventory/items', payload);
  return res.data as InventoryItem;
}

export async function updateItem(id: number, payload: Partial<InventoryItem>): Promise<InventoryItem> {
  const res = await client.put(`/api/v1/inventory/items/${id}`, payload);
  return res.data as InventoryItem;
}

export async function deleteItem(id: number): Promise<void> {
  await client.delete(`/api/v1/inventory/items/${id}`);
}

export async function listBatches(itemId: number): Promise<InventoryBatch[]> {
  const res = await client.get(`/api/v1/inventory/items/${itemId}/batches`);
  return res.data as InventoryBatch[];
}

export async function createBatch(itemId: number, payload: InventoryBatch): Promise<InventoryBatch> {
  const res = await client.post(`/api/v1/inventory/items/${itemId}/batches`, payload);
  return res.data as InventoryBatch;
}

export async function updateBatch(batchId: number, payload: Partial<InventoryBatch>): Promise<InventoryBatch> {
  const res = await client.put(`/api/v1/inventory/batches/${batchId}`, payload);
  return res.data as InventoryBatch;
}

function authHeaders(){
  const t = localStorage.getItem('accessToken');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export type AuditRow = {
  id: string; // composite id
  tenantName: string;
  itemName: string;
  locationId: number;
  qty: number;
  par: number;
  gap: number;
  lastTxn?: string;
};

export async function fetchInventoryAudit(params: { tenantId?: number; locationId?: number; page?: number; size?: number } = {}): Promise<{ content: AuditRow[]; totalElements: number }>{
  // Expected admin endpoint; fallback to empty if missing
  const res = await axios.get('/api/v1/super/inventory/audit', { params, headers: authHeaders() }).catch(() => ({ data: { content: [], totalElements: 0 } }));
  return res.data || { content: [], totalElements: 0 };
}


